var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 86,
    viewBox: "0 0 172 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.099 84.4596C153.323 85.2573 154.151 85.7226 154.948 85.499L167.947 81.8544C168.745 81.6307 169.21 80.8028 168.986 80.0051C168.763 79.2075 167.935 78.7421 167.137 78.9658L155.583 82.2054L152.343 70.651C152.119 69.8533 151.292 69.388 150.494 69.6117C149.696 69.8353 149.231 70.6632 149.454 71.4609L153.099 84.4596ZM3.07385 54.5547C16.1697 39.8293 36.2762 27.0097 58.1155 17.9159C79.9497 8.82411 103.368 3.51824 123.007 3.70019C142.735 3.88295 158.151 9.57526 164.797 21.885C171.457 34.2206 169.735 53.9628 153.236 83.3198L155.851 84.7896C172.464 55.2312 174.871 34.2305 167.437 20.4598C159.988 6.66331 143.087 0.886085 123.035 0.700316C102.895 0.513731 79.071 5.94033 56.9623 15.1464C34.8586 24.3503 14.3209 37.3938 0.832122 52.561L3.07385 54.5547Z",
    fill: "#F1B650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRounded);
export default __webpack_public_path__ + "static/media/arrow_rounded.f457c8312932f001929a960f3dae527f.svg";
export { ForwardRef as ReactComponent };